const nameSpace = 'admin/advertiser'

export const actions = {
  GET_ADVERTISER_LIST: `${nameSpace}/GET_ADVERTISER_LIST`,
  ADD_ADVERTISER: `${nameSpace}/ADD_ADVERTISER`,
  EDIT_ADVERTISER: `${nameSpace}/EDIT_ADVERTISER`,
  DELETE_ADVERTISER: `${nameSpace}/DELETE_ADVERTISER`,
}

export const getters = {
  advertiserList: `${nameSpace}/advertiserList`,
}
